var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgYandexPaytable = function SvgYandexPaytable(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 15.3137 16.3137 18 13 18C9.68629 18 7 15.3137 7 12C7 8.68629 9.68629 6 13 6C16.3137 6 19 8.68629 19 12Z",
    fill: "#7B61FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3357 15.5265H14.0995V9.39885H13.5475C12.5368 9.39885 12.0081 9.90495 12.0081 10.6602C12.0081 11.5167 12.3735 11.9138 13.1277 12.4199L13.7497 12.8403L11.9615 15.5265H10.632L12.2414 13.1284C11.3162 12.4666 10.7953 11.8203 10.7953 10.7303C10.7953 9.36771 11.7438 8.44116 13.5397 8.44116H15.3279V15.5265H15.3357Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYandexPaytable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "yandex-pay.table.a9374d0c7214c64c335abad5d2cf18c1.svg";